package org.zq.astrock_ai.network

import io.ktor.client.request.get
import io.ktor.client.request.header
import io.ktor.client.request.parameter
import io.ktor.client.statement.bodyAsText
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.Json
import org.zq.astrock_ai.api.ChartPeriod
import org.zq.astrock_ai.api.StockCodes
import org.zq.astrock_ai.api.dto.KlineBarDto
import org.zq.astrock_ai.api.dto.KlineResponseDto

/**
 * 客户端新浪日K兜底（东财直连失败时使用）。
 */
class SinaDirectClient(
    private val http: io.ktor.client.HttpClient = createMarketHttpClient(),
) {
    private val json = Json { ignoreUnknownKeys = true; isLenient = true }

    suspend fun fetchDailyKline(code: String, limit: Int = 120): KlineResponseDto? {
        val c = code.filter { it.isDigit() }.takeLast(6)
        if (c.length != 6) return null
        val symbol = StockCodes.toSinaCode(c)
        val text = runCatching {
            http.get(KLINE_URL) {
                parameter("symbol", symbol)
                parameter("scale", 240)
                parameter("ma", "no")
                parameter("datalen", limit.coerceIn(30, 250))
                header("User-Agent", UA)
                header("Referer", "https://finance.sina.com.cn")
            }.bodyAsText()
        }.getOrNull() ?: return null
        val rows = runCatching {
            json.decodeFromString<List<SinaKlineRow>>(text.trim())
        }.getOrDefault(emptyList())
        val bars = rows.mapNotNull { row ->
            val open = row.open?.toFloatOrNull() ?: return@mapNotNull null
            val close = row.close?.toFloatOrNull() ?: return@mapNotNull null
            val high = row.high?.toFloatOrNull() ?: return@mapNotNull null
            val low = row.low?.toFloatOrNull() ?: return@mapNotNull null
            val vol = row.volume?.toFloatOrNull() ?: 0f
            val day = row.day.orEmpty()
            if (day.isBlank() || close <= 0f) return@mapNotNull null
            KlineBarDto(date = day, open = open, close = close, high = high, low = low, volume = vol)
        }
        if (bars.isEmpty()) return null
        return KlineResponseDto(
            code = c,
            bars = bars,
            period = ChartPeriod.DAY.apiValue,
            chartType = ChartPeriod.DAY.chartType,
        )
    }

    @Serializable
    private data class SinaKlineRow(
        val day: String? = null,
        val open: String? = null,
        val high: String? = null,
        val low: String? = null,
        val close: String? = null,
        val volume: String? = null,
    )

    companion object {
        private const val UA = "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36"
        private const val KLINE_URL =
            "https://money.finance.sina.com.cn/quotes_service/api/json_v2.php/CN_MarketData.getKLineData"
    }
}
